import React from "react";
import { Collapse, Badge, Divider } from "antd";
import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";

const ResumenEcommerceModal = ({ visible, resumen, cerrarModal }) => {
  const r = resumen || {};
  const creados = r.creados || [];
  const yaTienen = r.yaTienen || [];
  const sinMatricula = r.sinMatricula || [];
  const correoOcupado = r.correoOcupado || [];
  const errores = r.errores || [];

  const filas = [
    {
      key: "creados",
      label: "Creados",
      count: creados.length,
      items: creados,
      icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
    },
    {
      key: "yaTienen",
      label: "Ya tenían cuenta",
      count: yaTienen.length,
      items: yaTienen,
      icon: <InfoCircleOutlined style={{ color: "#8c8c8c" }} />,
    },
    {
      key: "sinMatricula",
      label: "Sin matrícula",
      count: sinMatricula.length,
      items: sinMatricula,
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
    },
    {
      key: "correoOcupado",
      label: "Matrícula ya usada",
      count: correoOcupado.length,
      items: correoOcupado,
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
    },
    {
      key: "errores",
      label: "Errores",
      count: errores.length,
      items: errores,
      icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
    },
  ];

  const filasConItems = filas.filter((f) => f.count > 0);

  return (
    <ModalItem
      title="Resumen de generación"
      visible={visible}
      spinning={false}
      onCancel={cerrarModal}
      width={560}
    >
      {resumen && (
        <>
          <div style={{ textAlign: "center", padding: "8px 0 4px" }}>
            <div style={{ fontSize: 32, fontWeight: 600, lineHeight: 1.1 }}>
              {creados.length}
              <span style={{ fontSize: 18, color: "#8c8c8c", fontWeight: 400 }}>
                {" "}
                / {r.totalAlumnos}
              </span>
            </div>
            <div style={{ fontSize: 12, color: "#8c8c8c" }}>
              usuarios creados
            </div>
          </div>

          <Divider style={{ margin: "12px 0" }} />

          <div>
            {filas.map((f) => (
              <div
                key={f.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "6px 0",
                }}
              >
                {f.icon}
                <span style={{ flex: 1, color: "#595959" }}>{f.label}</span>
                <span style={{ fontWeight: 500 }}>{f.count}</span>
              </div>
            ))}
          </div>

          {filasConItems.length > 0 && (
            <>
              <Divider style={{ margin: "12px 0" }} orientation="left">
                <span style={{ fontSize: 12, color: "#8c8c8c" }}>Detalles</span>
              </Divider>
              <Collapse ghost>
                {filasConItems.map((f) => (
                  <Collapse.Panel
                    key={f.key}
                    header={
                      <span>
                        {f.label}{" "}
                        <Badge
                          count={f.count}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#595959",
                            marginLeft: 6,
                          }}
                        />
                      </span>
                    }
                  >
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {f.items.map((it) => (
                        <li
                          key={String(it.clienteId)}
                          style={{ color: "#595959" }}
                        >
                          {it.nombre}
                          {it.matricula ? ` — ${it.matricula}` : ""}
                          {it.message ? ` — ${it.message}` : ""}
                        </li>
                      ))}
                    </ul>
                  </Collapse.Panel>
                ))}
              </Collapse>
            </>
          )}

          <ButtonItem
            type="primary"
            onClick={cerrarModal}
            style={{ display: "block", margin: "16px 0 0 auto" }}
          >
            Aceptar
          </ButtonItem>
        </>
      )}
    </ModalItem>
  );
};

export default ResumenEcommerceModal;
